import StageType from "../../scripts/enums/StageType";
import {
  NarrationEntry,
  CharacterDefinition,
} from "../../components/Narration/narrationTypes";

// Define character metadata in one place
export const CHARACTERS: Record<string, CharacterDefinition> = {
  guide: {
    nameKey: "game.characters.guide",
    image: { type: "image", key: "old_man" },
  },
  suit_hamster: {
    nameKey: "game.characters.suit_hamster",
    image: { type: "spriteFrame", key: "suit_hamster", frame: 1 },
  },
};

// Define narration timing configuration
// Format: { stageType: { timeInMinutes: narrationId } }
export const TIME_BASED_NARRATIONS: Partial<
  Record<StageType, Record<number, string>>
> = {
  [StageType.DESERT1]: {
    0: "desert1-intro",
   // 0.5: "desert1-combat",
    1: "desert1-gems",
   // 1.5: "desert1-camels",
   // 3: "desert1-survive",
  },
  [StageType.DESERT2]: {
    2: "desert2-boss",
  },
  [StageType.DESERT3]: {
    0: "desert3-treasure",
  },
};

// Define all narration content in one place
export const NARRATION_ENTRIES: Record<string, NarrationEntry> = {
  // DESERT 1
  "desert1-intro": {
    character: "guide",
    text: "game.narration.desert1.intro",
    responses: [
      { text: "game.narration.desert1.responses.gold", nextId: "desert1-movement" },
      { text: "game.narration.desert1.responses.justice", nextId: "desert1-movement" },
      { text: "game.narration.desert1.responses.lost", nextId: "desert1-movement" },
    ],
  },
 // "desert1-intro-followup": {
 //   character: "guide",
 //   text: "game.narration.desert1.introFollowup",
 //   responses: [{ text: "game.narration.desert1.responses.goOn", nextId: "desert1-movement" }],
 // },
  "desert1-movement": {
    character: "guide",
    text: "game.narration.desert1.movement",
    responses: [{ text: "game.narration.desert1.responses.move", nextId: "desert1-combat" }],
  },
  "desert1-hamsters": {
    character: "guide",
    text: "game.narration.desert1.warningHamsters",
    responses: [{ text: "game.narration.desert1.responses.dodge", nextId: null }],
  },
  "desert1-combat": {
    character: "guide",
    text: "game.narration.desert1.combat",
    responses: [{ text: "game.narration.desert1.responses.dance", nextId: null }],
  },
  "desert1-gems": {
    character: "guide",
    text: "game.narration.desert1.gems",
    responses: [{ text: "game.narration.desert1.responses.gems", nextId: null }],
  },
  "desert1-camels": {
    character: "guide",
    text: "game.narration.desert1.camels",
    responses: [
      { text: "game.narration.desert1.responses.camelRob", nextId: null },
      { text: "game.narration.desert1.responses.camelMercy", nextId: null },
      { text: "game.narration.desert1.responses.camelLater", nextId: null },
    ],
  },
  "desert1-survive": {
    character: "guide",
    text: "game.narration.desert1.survive",
    responses: [{ text: "game.narration.desert1.responses.survive", nextId: null }],
  },

  // DESERT 2
  "desert2-boss": {
    character: "guide",
    text: "game.narration.desert2.bossApproaching",
    responses: [{ text: "game.narration.desert2.responses.ready", nextId: "desert2-suitHamster" }],
  },
  // Hamster in a Suit
  "desert2-suitHamster": {
    character: "suit_hamster",
    text: "game.narration.desert2.suitHamsterIntro",
    responses: [
      { text: "game.narration.desert2.responses.okay", nextId: "desert2-suitHamster-calm" },
      { text: "game.narration.desert2.responses.tap", nextId: "desert2-suitHamster-rage" },
    ],
  },
  "desert2-suitHamster-calm": {
    character: "suit_hamster",
    text: "game.narration.desert2.suitHamsterResponse1",
    responses: [{ text: "game.narration.desert2.responses.goOn", nextId: null }],
  },
  "desert2-suitHamster-rage": {
    character: "suit_hamster",
    text: "game.narration.desert2.suitHamsterResponse2",
    responses: [{ text: "game.narration.desert2.responses.goOn", nextId: null }],
  },
  
  // DESERT 3
  "desert3-treasure": {
    character: "guide",
    text: "game.narration.desert3.treasure",
    responses: [{ text: "game.narration.desert3.responses.treasureHunt", nextId: null }],
  },
};
